import { useT } from "../../contexts/LanguageContext";
import { Translate } from "@phosphor-icons/react";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useT();
  const next = lang === "tr" ? "en" : "tr";
  const onClick = () => setLang(next);
  return (
    <button
      onClick={onClick}
      className={`btn-secondary !py-2 !px-3 ${compact ? "text-xs" : "text-sm"} flex items-center gap-1.5`}
      data-testid="language-switcher"
      aria-label="Toggle language"
    >
      <Translate size={14} weight="bold" />
      <span className="font-mono font-bold tracking-wider">{lang.toUpperCase()}</span>
      <span className="text-slate-400">/</span>
      <span className="text-slate-400 font-mono">{next.toUpperCase()}</span>
    </button>
  );
}
